/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import { connect } from 'react-redux';
import {
  CEILINGS_CAPACITY_MULTIPLIER,
  INTERIOR_WALLS_COST_MULTIPLIER,
  STRUCTURAL_COST_MULTIPLIER,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import { modelTypesByForm } from '#src/js/constants/models/modelTypes/index.js';
import BuildingComponentSection from './BuildingComponentsSection.jsx';

const mapStateToProps = (state, ownProps) => {
  const { selectFormFieldVisibility } = modelTypesByForm[ownProps.form];
  return {
    hasWoodOrSteelLightFrame: selectFormFieldVisibility(state)(INTERIOR_WALLS_COST_MULTIPLIER),
    hasOtherBuildingType: selectFormFieldVisibility(state)(STRUCTURAL_COST_MULTIPLIER),
    hasComponentModifiers: selectFormFieldVisibility(state)(CEILINGS_CAPACITY_MULTIPLIER),
  };
};

export default connect(mapStateToProps)(BuildingComponentSection);
